var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bim"},[(_vm.link)?_c('iframe',{attrs:{"src":_vm.link,"sandbox":"allow-scripts allow-same-origin"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }